import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "box content has-text-centered" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Transaction hash: ")
const _hoisted_7 = { class: "mt-6 is-flex is-justify-content-center is-align-items-center" }
const _hoisted_8 = { class: "image is-64x64" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "modal-close is-large",
  "aria-label": "close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Transaction = _resolveComponent("Transaction")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", _ctx.dynamicClass])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.modalInfo.title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.modalInfo.message), 1),
        (_ctx.modalInfo.html)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.modalInfo.html
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.modalInfo.tx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Transaction, {
                value: _ctx.modalInfo.tx
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("figure", _hoisted_8, [
            _createElementVNode("img", {
              src: require('@/assets/loading.gif')
            }, null, 8, _hoisted_9)
          ])
        ])
      ])
    ]),
    _hoisted_10
  ], 2))
}